import React, {Component} from "react";
import axios from 'axios'
import userUtils from "../../utills/userUtils";

export default (WrappedComponent) => {
    return class extends Component {
        constructor(props) {
            super(props)
            this.state = {
                error: false,
            }
        }
        componentWillMount() {
            axios.interceptors.response.use((response) => {
                if(response.data && response.data.code && response.data.code === 401){
                    userUtils.doLogout()
                }
                return response;
            },  (error) => {
                this.setState({
                    error: true
                })
                return Promise.reject(error);
            });
        }
        render() {
            return (
                <WrappedComponent {...this.props}/>
            )
        }
    }
}